export const howItWorks_AIBackground = [
	{
		icon: '🖼',
		title: 'howItWorkData.title1',
		subtitle: 'howItWorkData.subtitle1',
	},
	{
		icon: '💬',
		title: 'howItWorkData.title2',
		subtitle: 'howItWorkData.subtitle2',
	},
	{
		icon: '✨',
		title: 'howItWorkData.title3',
		subtitle: 'howItWorkData.subtitle3',
	},
	{
		icon: '🤘',
		title: 'howItWorkData.title4',
		subtitle: 'howItWorkData.subtitle4',
	},
];
